export default __webpack_public_path__ + "static/media/cpg-factory.6105f4ee.svg";